import { ArticleFragment } from 'graphql/__generated/sdk';
import { ArticleTemplateProps, DataEntry } from 'pages/Article/models';
import { mapRelatedArticlesTitle } from 'pages/NewsArticle/mappers';
import { URL_LANGUAGE_ENUM } from 'utils/constants';
import { generateContentBlocks, mapAllRelatedArticlesFromTags } from 'utils/mappers';
import { generateImage, generateSeoMetadata } from 'utils/transformers';
import { slugLocaleMap } from 'utils/translation.utils';

function getHeroBannerVideoOrImage(
  video: ArticleFragment['mediaVideoCollection']['items'][0] | undefined,
  image: ArticleFragment['mediaImageCollection']['items'][0] | undefined
) {
  return {
    image: generateImage(video?.posterImage || image || {}),
    videoUrl: video?.video.url || '',
  };
}

export const mapArticleContent = (
  data: DataEntry,
  language: URL_LANGUAGE_ENUM
): ArticleTemplateProps => {
  const [article, tagsWithFilteredRelatedArticlesResponse] = data;

  const tagsWithFilteredRelatedArticles = tagsWithFilteredRelatedArticlesResponse?.data?.items;

  return {
    heroBanner: {
      ...getHeroBannerVideoOrImage(
        article.mediaVideoCollection.items[0],
        article.mediaImageCollection.items[0]
      ),
      title: article.title,
      preamble: article.preamble,
      cta: {
        text: '',
        url: '',
      },
    },
    contentBlocks: generateContentBlocks(article.body?.json),
    assetLinks: article.body?.links,
    carousel: {
      title: tagsWithFilteredRelatedArticles
        ? mapRelatedArticlesTitle(language, tagsWithFilteredRelatedArticles, article.category)
        : '',
      items: tagsWithFilteredRelatedArticles
        ? mapAllRelatedArticlesFromTags(
            tagsWithFilteredRelatedArticles,
            article[slugLocaleMap.get(language)!],
            language
          )
        : [],
    },
    seoMetadata: generateSeoMetadata(article.seoMetadata || {}),
  };
};
